import { Box, type SxProps, type Theme } from '@mui/material';
import React from 'react';

import { spaces } from '../../../../../assets/styles/themes/tokens';

const MuiCardBaseLongMetadataWrapper: React.FC<{
	children: React.ReactNode;
	sx?: SxProps<Theme>;
}> = ({ children, sx }) => (
	<Box
		className="mui-card-desktop__metadata-section"
		sx={{
			display: 'flex',
			flexDirection: 'row',
			gap: spaces.sm,
			flexWrap: 'wrap',
			...sx,
		}}
	>
		{children}
	</Box>
);

export default MuiCardBaseLongMetadataWrapper;
